/**
*
* Form4SingleField
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import Form4Separate from 'components/interaction/Form4/Form4Separate.jsx';

function Form4SingleField(props) {
  // eslint-disable-next-line no-unused-vars
  const { value, options, onChange, ...rest } = props;
  const { id } = options;
  const formId = `${id}-form`;
  const schema = { id: formId, properties: [options] };
  return (
    <Form4Separate
      defaultValues={{ [id]: value }}
      schema={schema}
      onSubmit={onChange}
      {...rest}
    />
  );
}

Form4SingleField.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  options: PropTypes.object,
};

export default Form4SingleField;
